"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectHome = selectHome;
function selectHome(_ref) {
  var pages = _ref.pages,
      site = _ref.site;
  var _pages$home = pages.home,
      callToActions = _pages$home.callToActions,
      highlightedJobs = _pages$home.highlightedJobs,
      matchMe = _pages$home.matchMe;
  var title = site.title,
      tagline = site.tagline,
      image = site.image,
      imageAlt = site.imageAlt,
      icon = site.icon,
      iconAlt = site.iconAlt;


  return {
    title: title,
    tagline: tagline,
    callToActions: callToActions,
    highlightedJobs: highlightedJobs,
    matchMe: matchMe,
    image: image,
    imageAlt: imageAlt,
    icon: icon,
    iconAlt: iconAlt
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Home/selectors.js
// module id = 1165
// module chunks = 0